import { render, staticRenderFns } from "./OurPartners.vue?vue&type=template&id=9484e47e&"
import script from "./OurPartners.vue?vue&type=script&lang=js&"
export * from "./OurPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports